<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f2f5">
    <pcHeaders></pcHeaders>

    <div class="cen">
      <div class="w">
        <!-- <div class="navTitle">
          <span @click="goNav(1)">首篇</span> > <span @click="goNav(2)">{{ text1 }}</span> <span v-if="text2 !== ''">></span>
          <span v-if="text2 !== ''">{{ text2 }}</span>
        </div> -->

        <div class="banner">
          <div class="leftBox">
            <div class="leftTitle">
              <div style="display: flex">
                <div style="display: flex">
                  <div>
                    <img src="../../assets/images/news.png" alt="中财专技" />
                  </div>
                  <div style="margin-left: 10px">新闻资讯</div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: center">
              <div style="padding-top: 30px">
                <div :class="tabIndex == 1 ? 'tabBox active' : 'tabBox'" @click="navTab(1, '06', '通知公告')">
                  <div>
                    <img v-if="tabIndex == 1" src="../../assets/images/wite.png" alt="中财专技" />
                    <img v-else src="../../assets/images/block.png" alt="中财专技" />
                  </div>
                  <div style="margin-left: 5px">通知公告</div>
                </div>
                <!-- <div :class="tabIndex == 2 ? 'tabBox active' : 'tabBox'" @click="navTab(2, '150101', '行业资讯')">
                  <div>
                    <img v-if="tabIndex == 2" src="../../assets/images/wite.png" alt="中财专技" />
                    <img v-else src="../../assets/images/block.png" alt="中财专技" />
                  </div>
                  <div style="margin-left: 5px">行业资讯</div>
                </div> -->
                <div :class="tabIndex == 3 ? 'tabBox active' : 'tabBox'" @click="navTab(3, '07', '政策法规')">
                  <div>
                    <img v-if="tabIndex == 3" src="../../assets/images/wite.png" alt="中财专技" />
                    <img v-else src="../../assets/images/block.png" alt="中财专技" />
                  </div>
                  <div style="margin-left: 5px">政策法规</div>
                </div>
                <!-- <div :class="tabIndex == 4 ? 'tabBox active' : 'tabBox'" @click="navTab(4, '1505', '职称评审')">
                  <div>
                    <img v-if="tabIndex == 4" src="../../assets/images/wite.png" alt="中财专技" />
                    <img v-else src="../../assets/images/block.png" alt="中财专技" />
                  </div>
                  <div style="margin-left: 5px">职称评审</div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="rightBox" v-if="text2 == ''">
            <div v-if="zixunList.length == 0" style="height: 550px; text-align: center; line-height: 550px; font-size: 20px">暂无数据~</div>
            <div class="newBox" v-for="(item, index) in zixunList" :key="item.id" @click="infoDetail(item.id, index)">
              <div :title="item.TITLE" style="width: 700px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ item.picTitle }}
              </div>
              <div>{{ item.createTime  }}</div>
            </div>

            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="toListMessage"
            />
          </div>

          <div class="rightBox" v-else>
            <div style="text-align: center; margin-top: 20px;font-size: 18px;">{{ title }}</div>
            <div style="display: flex;justify-content: center;">
              <div style="display: flex;margin: 10px 0;font-size: 16px;">
                {{ zxInfo.createTime }} 
              </div>
            </div>
            <div v-html="content" style="border-bottom: 1px dashed rgb(214, 214, 214); padding-bottom: 16px;font-size: 16px;"></div>
            <div style="width: 100%; margin-top: 20px">
              <div>
                <div class="updowBtn" @click="updow(1)">
                  <div :title="zxInfo.preTitle">上一篇：{{ zxInfo.preTitle == null ? '没有上一篇了' : zxInfo.preTitle }}</div>
                </div>
                <div class="updowBtn" @click="updow(2)" :title="zxInfo.lastTitle">
                  <div v-if="zxInfo.lastTitle !== null">下一篇：{{ zxInfo.lastTitle == null ? '没有下一篇了' : zxInfo.lastTitle }}</div>
                </div>
              </div>

              <!-- <div class="examHead">
                <div><img style="margin-top: 5px" src="../../assets/images/02_03.png" alt="中财专技" /></div>
                <div style="margin-left: 5px">相关新闻推荐</div>
              </div>
              <div style="margin-top: 10px">
                <div class="lst" @click="goTj(item.NAME)" v-for="item in msgInfo.relatedInfoMessageList" :key="item.NAME">
                  <div class="dian"></div>
                  <div style="margin-left: 5px">
                    {{ item.TITLE }}
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import flotRight from '@/views/component/flotRight.vue';
import { toListMessage, getInfoDetail } from '@/api/tzgg.js';
import { toGetMessage } from '@/api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {
      tabIndex: 1,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      code: '06',
      zixunList: [],
      text1: '通知公告',
      text2: '',
      content: '',
      title: '',
      zxIndex: '',
      zxInfo: {},
      msgInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goTj(name) {
      this.$router.push({
        path:'/bottomDetil',
        query:{
          name:name
        }
      })
    },
    getTj() {
      toGetMessage({ name: '529', codeNo: '1504' }).then(res => {
        this.msgInfo = res.data.data;
      });
    },
    updow(type) {
      console.log(this.zxInfo);

      if (type == 1) {
        if (this.zxInfo.preId == null) {
          return this.$message.error('没有上一篇了~');
        }
        this.infoDetail(this.zxInfo.preId);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        if (this.zxInfo.lastId == null) {
          return this.$message.error('没有下一篇了~');
        }
        this.infoDetail(this.zxInfo.lastId);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    //面包屑导航
    goNav(id) {
      if (id == 1) {
        this.$router.push('/');
        this.text2 = '';
      } else {
        this.navTab(this.tabIndex, this.code, this.text1);
        this.text2 = '';
      }
    },
    navTab(id, code, text) {
      this.tabIndex = id;
      this.code = code;
      this.toListMessage();
      this.text1 = text;
      this.text2 = '';
    },
    toListMessage() {
      this.queryParams.type = this.code;
      toListMessage(this.queryParams).then(res => {
        this.zixunList = res.data.rows;
        this.total = res.data.total;
      });
    },
    infoDetail(id, index) {
      getInfoDetail({ id: id,  type: this.code }).then(res => {
        this.zxInfo = res.data.data;
        this.content = res.data.data.picDesc;
        this.title = res.data.data.picTitle;
        this.text2 = '资讯详情';
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.toListMessage();
    window.scrollTo(0, 0);
    // 设置滚动行为改为平滑的滚动
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (this.$route.query.picType == '06') {
      this.navTab(1, this.$route.query.picType, '通知公告');
      this.infoDetail(this.$route.query.id)
    }else if (this.$route.query.picType == '07'){
       this.navTab(3, this.$route.query.picType, '政策法规');
      this.infoDetail(this.$route.query.id)
    }

    if (this.$route.query.id !== undefined && this.$route.query.id !== '') {
      this.infoDetail(this.$route.query.id);
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.lst {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 5px;
  .dian {
    width: 5px;
    height: 5px;
    background: #4075c0;
    margin-right: 5px;
  }
}
.examHead {
  margin-top: 18px;
  display: flex;
  font-size: 20px;
  border-bottom: 1px dashed #d6d6d6;
  border-top: 1px dashed #d6d6d6;
  padding: 10px 0;
}
.updowBtn {
  margin: 0 0px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  margin-bottom: 10px;
  .tzggTtile {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.updowBtn:hover {
  color: #3481f0;
}
.cen {
  font-family: Regular;
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  background: #f0f2f5;
  .w {
    width: 1400px;
    .navTitle {
      height: 58px;
      font-size: 14px;
      color: #999999;
      line-height: 58px;
      span {
        cursor: pointer;
      }
    }
    .banner {
      margin-top: 17px;
      display: flex;
      justify-content: space-between;
      .leftBox {
        width: 240px;
        height: 350px;
        background: #ffffff;
        opacity: 1;
        border-radius: 0px;
        .leftTitle {
          width: 240px;
          height: 55px;
          background: #417bb7;
          opacity: 1;
          border-radius: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 18px;
        }

        .tabBox {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #666666;
          cursor: pointer;
          width: 212px;
          height: 52px;
          margin-bottom: 4px;
          border-radius: 6px;
        }
        .active {
          background: #417bb7 !important;
          color: #fff !important;
        }
        .tabBox:hover {
          color: #417bb7;
        }
      }

      .rightBox {
        width: 1170px;
        min-height: 699px;
        background: #ffffff;
        opacity: 1;
        margin-left: 20px;
        padding: 20px 30px;
        .newBox {
          height: 70px;
          border-bottom: 1px solid #f0f2f5;
          color: #666666;
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          line-height: 70px;
          cursor: pointer;
        }
        .newBox:hover {
          color: #436cf3 !important;
        }
      }
    }
  }
}
</style>
